export default {

    setLoading(state, loadingStatus) {
        state.loading = loadingStatus;
    },

    setError(state, error) {
        state.error = error;
    },

    setAccessToken(state, token) {
        sessionStorage.setItem('accessToken', token);
        state.accessToken = token;
    },

    unsetAccessToken(state) {
        sessionStorage.removeItem('accessToken');
        state.accessToken = null;
    },

    setRefreshToken(state, token) {
        sessionStorage.setItem('refreshToken', token);
        state.refreshToken = token;
    },

    unsetRefreshToken(state) {
        sessionStorage.removeItem('refreshToken');
        state.refreshToken = null;
    },

    setUser(state, user) {
        state.user = user;
    }
};
